// src/pages/clientes/Clientes.js
import { useEffect, useState } from 'react'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../context/AuthContext'

const EMPTY = { nombre: '', tipo: 'empresa', ruc_nit: '', email: '', telefono: '', pais: '', ciudad: '', direccion: '', contacto_nombre: '', notas: '' }

export default function Clientes() {
  const { profile } = useAuth()
  const canWrite = ['admin', 'comercial'].includes(profile?.rol)
  const [clientes, setClientes] = useState([])
  const [loading, setLoading] = useState(true)
  const [modal, setModal] = useState(false)
  const [form, setForm] = useState(EMPTY)
  const [editId, setEditId] = useState(null)
  const [saving, setSaving] = useState(false)
  const [search, setSearch] = useState('')

  useEffect(() => { loadData() }, [])

  async function loadData() {
    setLoading(true)
    const { data } = await supabase.from('clientes').select('*').order('nombre')
    setClientes(data ?? [])
    setLoading(false)
  }

  function openNew() { setForm(EMPTY); setEditId(null); setModal(true) }
  function openEdit(c) {
    setForm({ nombre: c.nombre, tipo: c.tipo, ruc_nit: c.ruc_nit ?? '', email: c.email ?? '', telefono: c.telefono ?? '', pais: c.pais ?? '', ciudad: c.ciudad ?? '', direccion: c.direccion ?? '', contacto_nombre: c.contacto_nombre ?? '', notas: c.notas ?? '' })
    setEditId(c.id); setModal(true)
  }
  function onChange(e) { setForm(f => ({ ...f, [e.target.name]: e.target.value })) }
  async function save() {
    if (!form.nombre.trim()) return alert('El nombre es obligatorio')
    setSaving(true)
    if (editId) await supabase.from('clientes').update(form).eq('id', editId)
    else await supabase.from('clientes').insert([{ ...form, created_by: profile.id }])
    setSaving(false); setModal(false); loadData()
  }

  const filtered = clientes.filter(c => !search || c.nombre.toLowerCase().includes(search.toLowerCase()) || (c.pais ?? '').toLowerCase().includes(search.toLowerCase()))

  return (
    <div>
      <div className="page-header">
        <div><div className="page-title">🤝 Clientes</div><div className="page-subtitle">CRM y gestión de contactos comerciales</div></div>
        {canWrite && <button className="btn btn-primary" onClick={openNew}>+ Nuevo cliente</button>}
      </div>
      <div className="card">
        <input className="form-input" style={{ maxWidth: 300, marginBottom: 16 }} placeholder="Buscar por nombre o país..." value={search} onChange={e => setSearch(e.target.value)} />
        <div className="table-wrap">
          {loading ? <div style={{ textAlign: 'center', padding: 40 }}><div className="spinner spinner-dark" style={{ margin: 'auto' }} /></div>
            : (
              <table>
                <thead><tr><th>Nombre</th><th>Tipo</th><th>País</th><th>Email</th><th>Teléfono</th><th>Contacto</th>{canWrite && <th>Acciones</th>}</tr></thead>
                <tbody>
                  {filtered.length === 0 && <tr><td colSpan={7}><div className="empty-state">Sin clientes</div></td></tr>}
                  {filtered.map(c => (
                    <tr key={c.id}>
                      <td><strong>{c.nombre}</strong>{c.ruc_nit && <div style={{ fontSize: 11, color: 'var(--dark-500)' }}>{c.ruc_nit}</div>}</td>
                      <td><span className={`badge ${c.tipo === 'empresa' ? 'badge-blue' : 'badge-gray'}`}>{c.tipo}</span></td>
                      <td>{c.pais ?? '—'} {c.ciudad ? `/ ${c.ciudad}` : ''}</td>
                      <td>{c.email ?? '—'}</td>
                      <td>{c.telefono ?? '—'}</td>
                      <td>{c.contacto_nombre ?? '—'}</td>
                      {canWrite && <td><button className="btn btn-ghost btn-sm" onClick={() => openEdit(c)}>✏️</button></td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
        </div>
      </div>

      {modal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div className="modal modal-lg">
            <div className="modal-header">
              <div className="modal-title">{editId ? 'Editar cliente' : 'Nuevo cliente'}</div>
              <button className="btn btn-ghost btn-icon" onClick={() => setModal(false)}>✕</button>
            </div>
            <div className="form-grid">
              <div className="form-group" style={{ gridColumn: '1/-1' }}><label className="form-label">Nombre / Razón social *</label><input className="form-input" name="nombre" value={form.nombre} onChange={onChange} /></div>
              <div className="form-group"><label className="form-label">Tipo</label><select className="form-select" name="tipo" value={form.tipo} onChange={onChange}><option value="empresa">Empresa</option><option value="persona">Persona</option></select></div>
              <div className="form-group"><label className="form-label">RUC / NIT</label><input className="form-input" name="ruc_nit" value={form.ruc_nit} onChange={onChange} /></div>
              <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" name="email" value={form.email} onChange={onChange} /></div>
              <div className="form-group"><label className="form-label">Teléfono</label><input className="form-input" name="telefono" value={form.telefono} onChange={onChange} /></div>
              <div className="form-group"><label className="form-label">País</label><input className="form-input" name="pais" value={form.pais} onChange={onChange} /></div>
              <div className="form-group"><label className="form-label">Ciudad</label><input className="form-input" name="ciudad" value={form.ciudad} onChange={onChange} /></div>
              <div className="form-group"><label className="form-label">Persona de contacto</label><input className="form-input" name="contacto_nombre" value={form.contacto_nombre} onChange={onChange} /></div>
              <div className="form-group" style={{ gridColumn: '1/-1' }}><label className="form-label">Notas</label><textarea className="form-textarea" name="notas" value={form.notas} onChange={onChange} /></div>
            </div>
            <div className="modal-actions">
              <button className="btn btn-secondary" onClick={() => setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? 'Guardando...' : 'Guardar'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
